import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../../redux/actions/user.actions";
import { useNavigate } from "react-router-dom";
import { Badge, Row, Col, Button } from "react-bootstrap";
import {
  PencilSquare,
  Trash,
  Plus,
  Eye,
  Display,
  QuestionCircle,
} from "react-bootstrap-icons";
import AdminSidebar from "../../layouts/AdminSidebar";
import BookingTextMessagePreviewPopUp from "../../pages/activities/BookingTextMessagePreviewPopUp";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";
import VideoTutorialPopUp from "../VideoTutorialPopUp";
import webServices from "../../../services/webServices";

const EditListingVideo = AppConstants.tutorial.editListing;

function ActivityEditListing() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { current } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [activityList, setActivityList] = useState([]);
  const [filterActivityList, setFilterActivityList] = useState([]);
  const [show, setShow] = useState(false);
  const [details, setDetails] = useState({});
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [videoURL, setVideoURL] = useState("");

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const resp = await authCall("getActivityCode", { userId: current?.id });
      if (resp?.type === "success") {
        setActivityList(resp?.payload);
        setFilterActivityList(resp?.payload);
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleCostPerson = (id) => {
    navigate(AppConstants.routes.admin.updateCostPerson, {
      state: { activityId: id },
    });
  };

  const handleTourDetails = (id) => {
    navigate(AppConstants.routes.admin.updateCompanyDetails, {
      state: { activityId: id },
    });
  };

  const handleLocationDetails = (id) => {
    navigate(AppConstants.routes.admin.updateLocationDetails, {
      state: { activityId: id },
    });
  };

  const handleStopDetails = (id) => {
    navigate(AppConstants.routes.admin.updateStops, {
      state: { activityId: id },
    });
  };

  const handleDelete = (id) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(id)}
        >
          Yes
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (id) => {
    const resp = await authCall("deleteActivity", {
      bookingId: id,
    });
    if (resp?.type === "success") {
      closeToast();
      const updatedItems = activityList.filter((item) => item.id !== id);
      setFilterActivityList(updatedItems);
      toast.success("Deleted successfully.");
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleAdd = async () => {
    navigate(AppConstants.routes.admin.activityCompanyType);
    // setLoadingAdd(true);
    // const resp = await authCall("getCompanyDetails", {
    //   companyType: "Activity",
    //   userId: current?.id,
    // });
    // if (
    //   resp?.type === "success" &&
    //   resp?.payload?.is_profile_completed === "YES"
    // ) {
    //   setLoadingAdd(false);
    //   navigate(AppConstants.routes.admin.activityCompanyType);
    // } else {
    //   setLoadingAdd(false);
    //   navigate(AppConstants.routes.admin.actiityCreateCompany, {
    //     state: { isShowCompleteListing: true },
    //   });
    // }
  };

  // For Bootstrap Model
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setDetails(item);
    setShow(true);
  };

  const handleViewPublic = (el) => {
    navigate(AppConstants.routes.tour.home, { state: { activityId: el.id } });
  };

  const handleClickTutorial = () => {
    setVideoURL(EditListingVideo);
  };

  const tutoralClose = () => {
    setVideoURL("");
  };

  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title d-flex flex-wrap justify-content-between gap-2">
                  <span>Edit Listing</span>
                  <span
                    className="cursor-pointer"
                    onClick={handleClickTutorial}
                  >
                    <QuestionCircle />
                  </span>
                </div>
                <div className="details-wrapper py-lg-4">
                  <Row className="align-items-center mb-4">
                    <Col xs={4}></Col>
                    <Col xs={8} className="text-end">
                      <Button
                        className="btn btn-custom btn-custom-sm fs-16"
                        onClick={handleAdd}
                        disabled={loadingAdd || false}
                      >
                        <Plus />
                        {loadingAdd ? "Loading..." : "Create Activity"}
                      </Button>
                    </Col>
                  </Row>
                  <div className="table-responsive">
                    <table className="table table-borderless table-custom m-0">
                      <thead>
                        <tr>
                          <th scope="col">Id:</th>
                          <th scope="col">Product Code:</th>
                          <th scope="col">Activity Name:</th>
                          <th scope="col">Cost Per Person:</th>
                          <th scope="col">Activity Details:</th>
                          <th scope="col">Stop Details:</th>
                          <th scope="col">Location Details:</th>
                          <th scope="col">Status:</th>
                          <th scope="col">Action:</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading &&
                          (filterActivityList.length > 0 ? (
                            filterActivityList.map((el, index) => (
                              <tr key={index}>
                                <td scope="row">#{el.id}</td>
                                <td>{el.value}</td>
                                <td>{el.touchit_activity_name ? el.touchit_activity_name : el?.activity_name}</td>
                                <td className="text-blue">
                                  <div
                                    onClick={() => handleCostPerson(el.id)}
                                    className="cursor-pointer"
                                  >
                                    <PencilSquare /> Edit
                                  </div>
                                </td>
                                <td className="text-blue">
                                  <div
                                    onClick={() => handleTourDetails(el.id)}
                                    className="cursor-pointer"
                                  >
                                    <PencilSquare /> Edit
                                  </div>
                                </td>
                                <td className="text-blue">
                                  {el.company_type === "Tour" && (
                                    <div
                                      onClick={() => handleStopDetails(el.id)}
                                      className="cursor-pointer"
                                    >
                                      <PencilSquare /> Edit
                                    </div>
                                  )}
                                </td>
                                <td className="text-blue">
                                  <div
                                    onClick={() => handleLocationDetails(el.id)}
                                    className="cursor-pointer"
                                  >
                                    <PencilSquare /> Edit
                                  </div>
                                </td>
                                <td>
                                  <Badge bg={el.status_bg}>{el.status}</Badge>
                                </td>
                                <td>
                                  <div className="icon-container">
                                    <Eye
                                      onClick={() => handleShow(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "#ddb12e",
                                      }}
                                    />
                                    <Display
                                      onClick={() => handleViewPublic(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "#ddb12e",
                                      }}
                                      title="Click to public view"
                                    />
                                    <Trash
                                      onClick={() => handleDelete(el.id)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "red",
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No record found
                              </td>
                            </tr>
                          ))}
                        {loading && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookingTextMessagePreviewPopUp
        show={show}
        handleClose={handleClose}
        // details={details}
        details={{
          activity_name: details?.activity_name,
          company_phone: details.company_phone,
          location: details?.location,
          what_to_bring: details.what_to_bring,
          locationDescription: details?.location_description,
          isBookingCancel: details?.is_booking_cancel === "1" || false,
        }}
      />
      <VideoTutorialPopUp videoURL={videoURL} closeVideo={tutoralClose} />
    </>
  );
}

export default ActivityEditListing;
